import React from 'react';

const TermsOfUsePage = () => {
  return (
    <main className="bg-white min-h-screen">
      <section className="py-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-6">
            Terms of <span className="text-brand-red">Use</span>
          </h1>

          <p className="text-gray-500 text-sm mb-10">
            Last updated: August 2026
          </p>

          <div className="space-y-8 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing and using the Alakhe Conglomerate (Pty) Ltd
                website, you agree to comply with these Terms of Use. If you
                do not agree with these terms, please do not use the website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                2. Website Information
              </h2>
              <p>
                The information provided on this website is intended for
                general informational purposes. While we make reasonable
                efforts to ensure that the information is accurate and
                current, we do not guarantee that all information is complete,
                accurate, or up to date at all times.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                3. Use of the Website
              </h2>
              <p>
                You agree to use this website lawfully and responsibly. You
                must not use the website in a manner that could damage,
                disable, overburden, or interfere with its operation or
                security.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                4. Intellectual Property
              </h2>
              <p>
                Unless otherwise stated, the content, branding, graphics,
                logos, text, images, and other materials displayed on this
                website are owned by or licensed to Alakhe Conglomerate (Pty)
                Ltd and may not be reproduced or distributed without
                appropriate permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                5. Third-Party Links
              </h2>
              <p>
                This website may contain links to third-party websites or
                services. These links are provided for convenience, and
                Alakhe Conglomerate is not responsible for the content,
                availability, or practices of third-party websites.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                6. Limitation of Liability
              </h2>
              <p>
                To the extent permitted by applicable law, Alakhe Conglomerate
                shall not be liable for any direct, indirect, incidental, or
                consequential loss arising from the use of, or inability to
                use, this website or reliance on information provided through
                it.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                7. Changes to These Terms
              </h2>
              <p>
                We may update these Terms of Use from time to time. Any
                changes will be reflected on this page by updating the
                "Last updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                8. Governing Law
              </h2>
              <p>
                These Terms of Use are governed by the laws of the Republic
                of South Africa.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-charcoal mb-3">
                9. Contact Us
              </h2>
              <p>
                If you have any questions regarding these Terms of Use,
                please contact Alakhe Conglomerate through the contact details
                provided on this website.
              </p>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsOfUsePage;